import {
  CommonFormDataToLegacyPayloadProps,
  LegacyProposalRequestProps,
  mapSubmitDataUtils,
  submitLegacyProposal,
} from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/Common';

import { LegacyProposalAPI } from '../../../data';

import { BonusProposalFormData } from './';

export type BonusSubmitData = {
  fEmplId: number;
  fEmplSubUId?: string;
  fIncentiveShortProposalAmount: string;
  fIncentiveShortProposalHigherMgrId: number;
  fIncentiveShortProposalHrId: number;
  fIncentiveShortProposalInfo: string;
  fIncentiveShortProposalManagerId: number;
  fIncentiveShortProposalPaymentDate: string;
  fIncentiveShortProposalPaymentPeriod: string;
  fIncentiveShortProposalPaymentPeriodEndDate: string;
  fIncentiveShortProposalPaymentPeriodStartDate: string;
  fIncentiveShortProposalRecurrence: string;
  fIncentiveShortProposalStatus: string;
  fIncentiveShortProposalType: string;
};

export const mapFormDataToLegacyPayload = (
  props: CommonFormDataToLegacyPayloadProps<BonusProposalFormData>,
): BonusSubmitData => {
  const {
    data,
    isHRUser,
    loggedInEmployeeId,
    decision,
    requestProps: { employeeId, proposalId },
  } = props;
  const {
    submissionResponsibleHR,
    submissionDateInFormat,
    submissionProposalStatus,
  } = mapSubmitDataUtils({ defaultSubmissionDateFormat: 'YYYY-MM-DD' });

  return {
    fEmplId: +data?.employmentId || employeeId,
    fEmplSubUId: proposalId,
    fIncentiveShortProposalAmount: data.bonusAmount.toString(),
    fIncentiveShortProposalHigherMgrId: -1,
    //TODO: IF I HR OR ADMIN I CAN'T SELECT OTHER HR. needs new API...
    fIncentiveShortProposalHrId: submissionResponsibleHR(data.responsibleHR),
    fIncentiveShortProposalInfo: data.info || '',
    //TODO: mock number but should be checked
    fIncentiveShortProposalManagerId: isHRUser ? 1 : loggedInEmployeeId,
    fIncentiveShortProposalPaymentDate: submissionDateInFormat(
      data.paymentDate,
    ),
    fIncentiveShortProposalPaymentPeriod: data.paymentPeriodInfo || '',
    fIncentiveShortProposalPaymentPeriodEndDate: submissionDateInFormat(
      data.paymentPeriodEndDate,
    ),
    fIncentiveShortProposalPaymentPeriodStartDate: submissionDateInFormat(
      data.paymentPeriodStartDate,
    ),
    fIncentiveShortProposalRecurrence: data.recurrence?.toString() || '',
    fIncentiveShortProposalStatus: submissionProposalStatus({
      isHRUser,
      decision,
    }),
    fIncentiveShortProposalType: data.bonusType,
  };
};

export const submitShortIncentiveProposal = async (
  data: BonusSubmitData,
  requestProps: LegacyProposalRequestProps,
) =>
  submitLegacyProposal<BonusSubmitData>(
    LegacyProposalAPI.BonusProposal,
    data,
    requestProps,
  );
